<template>
  <span
    class="AppLogo"
    :style="[
      { width: `${width}px` }
    ]"
  >
    <img src="@/assets/images/logo.svg" alt="logo">
  </span>
</template>

<script setup>

defineOptions({
  name: 'AppLogo'
});

const props = defineProps({
  width: {
    type: Number,
    default: 78
  }
});
</script>

<style lang="scss">
  .AppLogo {
    display: inline-flex;
    vertical-align: middle;
    outline: none;
    align-items: center;

    img {
      width: 100%;
      height: auto;
      max-height: 100%;
    }
  }
</style>
